<template>
    <AsPopupContainer>
        <AsLabel>A/S 할 품목을 선택해주세요.</AsLabel>
        <TableContainer>
            <AsTable>
                <thead>
                    <tr>
                        <AsTh>
                            <AsCheckbox type="checkbox" v-model="allSelected" @change="toggleSelectAll" />
                        </AsTh>
                        <AsTh>품목코드</AsTh>
                        <AsTh>바코드</AsTh>
                        <AsTh>품목분류</AsTh>
                        <AsTh>품목명</AsTh>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(product, index) in localProducts" :key="product.id">
                        <AsTd>
                            <AsCheckbox type="checkbox" :checked="product.selected" @change="toggleProduct(index)" />
                        </AsTd>
                        <AsTd>{{ product.code }}</AsTd>
                        <AsTd>{{ product.bcode }}</AsTd>
                        <AsTd>{{ product.name || product.name1 }}</AsTd>
                        <AsTd>{{ product.name2 || product.name3 }}</AsTd>
                    </tr>
                </tbody>
            </AsTable>
        </TableContainer>

        <AsDetails>
            <AsLabel>A/S 접수일자:</AsLabel>
            <AsInput type="date" v-model="asDate" />
        </AsDetails>

        <AsRequest>
            <AsLabel>수리/보수 요청사항:</AsLabel>
            <AsTextarea rows="5" cols="50" v-model="requestNote" placeholder="요청사항을 입력하세요">
            </AsTextarea>
        </AsRequest>
    </AsPopupContainer>
</template>

<script>
import * as OrderAsPopupCss from '@/assets/styles/order/popup/OrderAsPopupCss.js';

export default {
    name: 'OrderAsPopup',

    props: {
        products: {
            type: Array,
            required: true
        },
        orderId: {
            type: [String, Number],
            required: true
        }
    },

    components: {
        ...OrderAsPopupCss
    },

    data() {
        return {
            allSelected: false,
            selectedProducts: [],
            localProducts: [],
            todayDate: new Date().toISOString().split('T')[0],
            asDate: new Date().toISOString().split('T')[0],
            requestNote: ''
        };
    },

    methods: {
        // 전체 선택
        toggleSelectAll(event) {
            const isChecked = event.target.checked;
            this.allSelected = isChecked;

            this.localProducts.forEach(product => {
                product.selected = isChecked;
            });

            this.updateSelectedProducts();
        },

        toggleProduct(index) {
            // 개별 제품의 선택 상태를 토글
            this.localProducts[index].selected = !this.localProducts[index].selected;

            // 전체 선택 상태 업데이트
            this.allSelected = this.localProducts.every(product => product.selected);

            this.updateSelectedProducts();
        },

        updateSelectedProducts() {
            this.selectedProducts = this.localProducts
                .filter(product => product.selected)
                .map(product => ({
                    id: product.b_product_id || product.id,
                    code: product.code,
                    bcode: product.barcodes && product.barcodes.length > 0 ? product.barcodes[0] : '',
                    name: product.name || product.name1,
                    name2: product.name2 || product.name3,
                    quantity: 1,
                    as_reason: this.requestNote,
                    buyprice: product.buyprice || 0,
                    rentprice: product.rentprice || 0,
                    selected_target: product.selected_target || '구입',
                    options: {
                        size: product.size || '',
                        color: product.color || '',
                        bcode: product.barcodes && product.barcodes.length > 0 ? product.barcodes[0] : '',
                        note: product.note || ''
                    }
                }));
            this.$emit('updateSelected', this.selectedProducts);
        },

        handleDateChange(event) {
            this.asDate = event.target.value;
        },

        getAsData() {
            return {
                asDate: this.asDate,
                request: this.requestNote,
                products: this.selectedProducts
            };
        }
    },

    created() {
        this.localProducts = this.products.map(product => ({
            ...product,
            selected: false,
            bcode: product.barcodes && product.barcodes.length > 0 ? product.barcodes[0] : '',
            name: product.name || product.name1,
            name2: product.name2 || product.name3
        }));
    },

    watch: {
        products: {
            handler(newProducts) {
                this.localProducts = newProducts.map(product => ({
                    ...product,
                    selected: false,
                    name: product.name || product.name1,
                    name2: product.name2 || product.name3
                }));
            },
            deep: true
        }
    }
};
</script>